import { Component, computed, input } from '@angular/core';
import { Block } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-hero-split-layout',
    standalone: false,
    templateUrl: './hero-split-layout.component.html',
    styleUrl: './hero-split-layout.component.scss',
})
export class HeroSplitLayoutComponent {
    block = input.required<Block>();
    hasCustomHeadingTypography = input<boolean>(false);
    hasCustomDescriptionTypography = input<boolean>(false);

    heroContainerStyles = computed(() => {
        const description = String(this.block().data.description ?? '').trim();
        const noDescription = description.length === 0;
        const noImage = !this.block().data.includeImage;

        return {
            '--hero-container-min-height--mobile': this.block().data.bannerMinHeightMobile,
            '--hero-container-min-height--tablet': this.block().data.bannerMinHeightTablet,
            '--hero-container-min-height--desktop': this.block().data.bannerMinHeightDesktop,

            '--content-width': this.block().data.contentMaxWidth,

            ...(this.block().data.useCustomImageContainerPadding && {
                '--hero-image-container-padding--mobile': this.block().data.imageContainerPaddingMobile,
                '--hero-image-container-padding--tablet': this.block().data.imageContainerPaddingTablet,
                '--hero-image-container-padding--desktop': this.block().data.imageContainerPaddingDesktop,
            }),

            ...(this.block().data.useCustomImageHeight && {
                '--hero-image-height--mobile': this.block().data.imageHeightMobile,
                '--hero-image-height--tablet': this.block().data.imageHeightTablet,
                '--hero-image-height--desktop': this.block().data.imageHeightDesktop,
            }),

            ...(this.block().data.useCustomImagePosition && {
                '--hero-image-position--mobile': this.block().data.imagePositionMobile,
                '--hero-image-position--tablet': this.block().data.imagePositionTablet,
                '--hero-image-position--desktop': this.block().data.imagePositionDesktop,
            }),

            ...(this.block().data.useCustomImageSize && {
                '--hero-image-size--mobile': this.block().data.imageSizeMobile,
                '--hero-image-size--tablet': this.block().data.imageSizeTablet,
                '--hero-image-size--desktop': this.block().data.imageSizeDesktop,
            }),

            // Component-scoped padding overrides when both description and image are absent
            ...(noDescription &&
                noImage && {
                    '--hero-split-layout-padding--desktop': '4rem 3rem',
                    '--hero-split-layout-padding--tablet': '4rem 3rem',
                    '--hero-split-layout-padding--mobile': '3rem 2rem',
                }),
        } as Record<string, string | undefined>;
    });
}
